export default function About() {
    return (
        <h1>About</h1>
    )
}